export default __webpack_public_path__ + "static/media/rikoon-logo.94ba6f4c.png";